var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.23669 12.9178C2.02367 12.9178 1.70414 12.8119 1.49112 13.3414C1.1716 14.1884 0.852071 15.0355 0.639053 15.8825L0.319527 16.9414C0.319527 16.9414 0.319527 17.0472 0.213018 17.1531L0 18.0002L5.11243 16.3061V15.9884C4.7929 14.1884 3.40828 13.2355 2.23669 12.9178Z",
    fill: "#5BB3C7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.574 2.11846C17.0414 1.58904 16.5089 0.95375 15.8698 0.424339C15.3373 -0.105073 14.6982 -0.105073 14.0592 0.318456C13.9527 0.424339 13.7396 0.636103 13.6331 0.741986L13.4201 1.05963L13.3136 1.16552C13.3136 1.16552 13.3136 1.16552 13.2071 1.2714L12.9941 1.48316L12.8876 1.58904L16.4024 5.08316L16.8284 4.65963C17.0414 4.44787 17.1479 4.34199 17.2544 4.2361L17.3609 4.13022L17.6805 3.81257C18.1065 3.17728 18.1065 2.54199 17.574 2.11846Z",
    fill: "#5BB3C7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.30176 11.2237L3.94081 11.4354C5.21892 11.859 6.1775 12.8119 6.60353 14.0825L6.81655 14.7178L14.9112 6.67073L15.0177 6.35308L11.6094 2.96484L3.30176 11.2237Z",
    fill: "#5BB3C7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.fcd43ff2cedb311915a86bc046900f7d.svg";
export { ForwardRef as ReactComponent };